import React from 'react';
import K from '../../k';

const Button = ({disabled, href, icon, target, style, contentStyle, onClick, children, ...rest}) => {
  const styles = {
    button: {
      position: 'relative',
      border: 'none',
      minHeight: 30,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: 0,
      borderRadius: K.borderRadius,
      overflow: 'hidden',
      ...(disabled ? K.disabled : {}),
      ...K.preventSelection,
      ...style,
    },
    content: {
      display: 'flex',
      justifyContent: 'start',
      alignItems: 'center',
      ...contentStyle
    },
  };

  return (
    <button {...{target, href, disabled, onClick, ...rest}} className={'hoverable'} style={styles.button}>
      <span style={styles.content}>{children}</span>
      {icon}
    </button>
  );
};

export default Button;